import i18n from '@/i18n'
import { SUPPORTED_LANGUAGES } from '@/utils/i18n'

// 从 localStorage 加载保存的语言设置
const savedLocale = localStorage.getItem('locale') || 'zh-CN'

// 检查保存的语言是否在支持列表中
const isValidLocale = SUPPORTED_LANGUAGES.some(lang => lang.value === savedLocale)
const initialLocale = isValidLocale ? savedLocale : 'zh-CN'

const state = {
  locale: initialLocale
}

const mutations = {
  SET_LOCALE(state, locale) {
    state.locale = locale
    localStorage.setItem('locale', locale)
  }
}

const actions = {
  setLocale({ commit, dispatch }, locale) {
    commit('SET_LOCALE', locale)
    // 同步更新 i18n 实例
    i18n.locale = locale
  }
}

const getters = {
  locale: state => state.locale,
  languageName: state => {
    const lang = SUPPORTED_LANGUAGES.find(l => l.value === state.locale)
    return lang ? lang.name : '简体中文'
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
